export default "__VITE_ASSET__BE8EuBF3__"